import React, { Component } from 'react'
import {connect} from "react-redux"
import trans, { isTrans } from "trans"
import { AxiosResponse } from 'axios';
import { debounce, find, sortBy } from 'lodash';

import {
    Templates,
    POST_TEMPLATE,
    setSavingTemplate,
    setTemplatesToStore,
    setSizesToStore,
    setAlternativeTemplatesToStore,
    setAlternativeTemplatesLevelsToStore,
    setBlockNavigation,
} from '../reducers';

import { initForm, updateInputValue as change } from "app/reducers/form"

import {
    css,
    Button,
    TextInput,
    Grid,
    GridCell,
    Theme,
    Icon,
    Select,
} from "@bdfx/mergado-ui-kit"

/* import { Select } from '@mus/core' */

import { projectId, eshopId, getSizes, getAlternativeTemplatesLevels } from "app/helpers/api"
import { getProjectCollageLayouts, saveTemplate as apiSaveTemplate } from "app/helpers/api"
import toastFactory, { textToast } from "app/helpers/toast_factory"
import { RouterType, withRouter } from 'app/components/routes';
import { selectFormValues } from 'app/reducers/form';
import { AlternativeTemplatesLevels, CollageLayoutType, emptyEffects, Template } from 'app/types/model-types';
import { AlternativeImage, RandomProduct } from 'shape-edit/types';
import { createToast } from 'actions';
import { clearHistory, TemplateOrAlternativeTemplateType } from '../undoRedoReducers';
import { setActiveView } from 'shape-edit/reducers';
import { Option } from '@bdfx/mergado-ui-kit/lib/components/Form/Select';
import { MAX_ALTERNATIVE_IMAGES } from 'settings/components/collage-layouts-images';
import { ACTIVE_VIEW_EDIT_QUERIES, ACTIVE_VIEW_EDIT_SOURCE_IMAGE, UpdateEffectsFunctionType } from 'template-edit/containers/Editor';
import Shape from 'shape-entities/types/shape';
import { SizeItem } from 'settings/components/sizes-settings';
import { getFormName, getSelectedAltLevels } from 'shape-edit/forms/helpers';
import { ReduxList } from 'app/types/app-types';
import { DO_NOT_SAVE_HISTORY } from 'template-edit/sagas/undoRedoHistory';

const iconSize = 18

interface Props {
    updateEffects: UpdateEffectsFunctionType
    router: RouterType
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    collageLayoutsForm: CollageLayoutType[]
    randomProduct: RandomProduct
    sizes: ReduxList<SizeItem>
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels>
    templates: Templates
    change: typeof change
    checkIsValid: boolean
    setSavingTemplate: typeof setSavingTemplate
    setTemplatesToStore: typeof setTemplatesToStore
    setAlternativeTemplatesToStore: typeof setAlternativeTemplatesToStore
    setAlternativeTemplatesLevelsToStore: typeof setAlternativeTemplatesLevelsToStore
    setActiveView: typeof setActiveView
    setSizesToStore: typeof setSizesToStore
    setBlockNavigation: typeof setBlockNavigation
    createToast: typeof createToast
    clearHistory: typeof clearHistory
    initForm: typeof initForm
}

export const LEVELS_MODE_ALL = 'all';
export const LEVELS_MODE_FIRST = 'first';
export const LEVELS_MODE_LAST = 'last';
export const LEVELS_MODE_SELECTED = 'selected';

export type LevelsModeType = 'first' | 'last' | 'all' | 'selected'

export const levelsModeOptions = (first: AlternativeImage, last: AlternativeImage): Option[] => [
    { label: trans('all'), text: trans('all'), value: LEVELS_MODE_ALL},
    {
        label: trans('first'),
        text: (first && first.url) ? <Grid cols={'1fr 1fr'}>
            <GridCell>{trans('first')}</GridCell>
            <GridCell>{<img src={first.url} style={{ maxWidth: '30px', maxHeight: '30px' }} />}</GridCell>
        </Grid> : trans('first'),
        value: LEVELS_MODE_FIRST
    },
    {
        label: trans('last'),
        text: (last && last.url) ? <Grid cols={'1fr 1fr'}>
            <GridCell>{trans('last')}</GridCell>
            <GridCell><img src={last.url} style={{ maxWidth: '30px', maxHeight: '30px' }} /></GridCell>
        </Grid> : trans('last'),
        value: LEVELS_MODE_LAST
    },
    { label: trans('selected'), text: trans('selected'), value: LEVELS_MODE_SELECTED},
];

export const availableLevels = (alternativeImages: AlternativeImage[]): Option[] => [...Array(MAX_ALTERNATIVE_IMAGES).keys()]
    .map((level) => {
        const i = alternativeImages ? find(alternativeImages, (alt) => {
            return `${alt.level}` === `${level}`
        }) : null

        const textLabel = `${level + 1}`

        return {
            label: textLabel,
            text: (i && i.url) ? <Grid cols={'1fr 1fr'}>
                <GridCell>{textLabel}</GridCell>
                <GridCell><img src={i.url} style={{ maxWidth: '30px', maxHeight: '30px' }} /></GridCell>
            </Grid> : textLabel,
            value: `${level}`,
        }
    })


interface State {
    name: string
    levelsMode: LevelsModeType
    altLevels: string[]
}

export const MAX_TEMPLATE_NAME_LENGHT = 100

class SaveTemplateForm extends Component<Props, State> {
    constructor(props) {
        super(props)

        const a = getSelectedAltLevels()

        this.state = {
            name: props.form.name,
            levelsMode: a?.mode,
            altLevels: a?.levels,
        }
    }

    updateEffectsDebounced = debounce(() => {
        const { randomProduct, form, isAlt } = this.props
        const { altLevels, levelsMode } = this.state
        const currentEffects = form.effects ? { ...form.effects } : { ...emptyEffects }

        this.props.updateEffects(randomProduct.id, currentEffects, form.is_autocrop, altLevels, levelsMode)
    }, 200)

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown)
    }

    updateSizes = () => {
        getSizes()
            .then((response: AxiosResponse<SizeItem[]>) => {
                this.props.setSizesToStore(response.data)
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })
    }

    updateLevels = () => {
        getAlternativeTemplatesLevels()
            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                this.props.setAlternativeTemplatesLevelsToStore(response.data)
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })
    }

    handleChangeName = (newName: string) => {
        const updatedName = newName?.substring(0, MAX_TEMPLATE_NAME_LENGHT)
        this.setState({name: updatedName})
        this.updateNameDebounced(updatedName)
    }

    updateNameDebounced = debounce((newName: string) => {
        const { isAlt } = this.props
        const formName = getFormName(isAlt)
        this.props.change(formName, "name", newName, DO_NOT_SAVE_HISTORY)
    }, 200)

    handleKeyDown = (event) => {
        //do not prevent default for
        if (event.target.type || ['TEXTAREA', 'INPUT'].includes(event.target.tagName)) {
            return;
        }

        if (event.ctrlKey) {
            switch (event.key) {
                case 's':   //save
                case 'S':
                    event.preventDefault()
                    this.saveTemplate(false, false)
                    break;
            }
        }
    }

    saveTemplate = (returnToHomepage: boolean, saveAsNew: boolean) => {
        const { randomProduct, collageLayoutsForm, router, templates, form, isAlt } = this.props
        const formName = getFormName(isAlt)
        const { shapes } = form

        if (templates.isSaving) {
            return;
        }

        const collageLayout = collageLayoutsForm && form.collage_layout_id ? find(collageLayoutsForm, (c: CollageLayoutType) => {
            return c.id === form.collage_layout_id
        }) : null

        this.props.setSavingTemplate(true)

        const newShapes = Object.keys(shapes).map(i => {
            const shape : Shape = {
                ...shapes[i],
                id: saveAsNew ? null : shapes[i].id,    //save as new --> set null to shape ids!!!!
            }
            return shape
        })

        const updatedTemplateForm: Template = {
            ...form,
            random_product_id: randomProduct?.id,
            shapes: newShapes,
            collage_layout: collageLayout,
            id: saveAsNew ? 'new' : form.id,
        }

        const altLevels = isAlt ? this.state.altLevels : []
        const levelsMode = isAlt ? this.state.levelsMode : null

        apiSaveTemplate(updatedTemplateForm, saveAsNew ? 'new' : router.params.template_id, router.params.alt_template_id, isAlt, altLevels, levelsMode)
            .then((response: AxiosResponse<TemplateOrAlternativeTemplateType[]>) => {
                const updatedTemplates = response.data
                this.props.clearHistory(updatedTemplateForm)
                this.props.createToast(toastFactory(POST_TEMPLATE.SUCCESS))
                this.props.setBlockNavigation(false)

                const currentTemplate = !saveAsNew ? find(updatedTemplates, (template: TemplateOrAlternativeTemplateType) => {
                    return template.id === updatedTemplateForm.id
                }) : null

                if (isAlt) {
                    this.props.setAlternativeTemplatesToStore(updatedTemplates)
                    this.updateLevels()
                } else {
                    this.props.setTemplatesToStore(updatedTemplates)
                }

                this.updateSizes()

                if (returnToHomepage) {
                    router.navigate(`/eshop/${eshopId}/project/${projectId}`)
                } else if (saveAsNew || !updatedTemplateForm.id) {
                    const updatedTemplate = updatedTemplates[updatedTemplates.length - 1] //the last one */

                    const size = updatedTemplate.size_id ? find(this.props.sizes.data, (size) => {
                        return `${updatedTemplate.size_id}` === `${size.id}`
                    }) : null

                    //add all relations:
                    const templateWithRelations = {
                        ...updatedTemplate,
                        effects: (updatedTemplate.effects || updatedTemplateForm.effects),
                        size: updatedTemplate.size ? updatedTemplate.size : size,
                    }

                    this.props.initForm(formName, templateWithRelations)

                    router.navigate(isAlt ?
                        `/eshop/${eshopId}/project/${projectId}/templates/${router.params.template_id}/edit-alt/${updatedTemplate.id}` :
                        `/eshop/${eshopId}/project/${projectId}/templates/${updatedTemplate.id}/edit`
                    )
                } else if (currentTemplate) {
                    if (currentTemplate.size_id !== updatedTemplateForm.size?.id) {
                    }
                    this.props.initForm(formName, currentTemplate)   //re-init template form (may be load some relations too?)
                }

                if (collageLayout && `${collageLayout.id}`.startsWith('_')) {
                    getProjectCollageLayouts()
                        .then((response: AxiosResponse<CollageLayoutType[]>) => {
                            this.props.initForm('collageLayoutsForm', response.data)
                        })
                        .catch(error => {
                            console.error('cannot get collage updated collage layouts', error)
                        })
                }
            })
            .catch(error => {
                console.error('save template error', error)
                if (error.response && error.response.data && error.response.data.validation_errors) {
                    const { validation_errors } = error.response.data
                    if (validation_errors) {
                        Object.keys(validation_errors).forEach(e => {
                            const s = `validation_error_${e}`
                            if (isTrans(s)) {
                                this.props.createToast(textToast('error', trans(s)))
                            } else {
                                this.props.createToast(textToast('error', s))
                            }
                        })
                    }

                    if (validation_errors.queries) {
                        this.props.setActiveView(ACTIVE_VIEW_EDIT_QUERIES)
                    } else if (validation_errors.format) {
                        this.props.setActiveView(ACTIVE_VIEW_EDIT_SOURCE_IMAGE)
                    }
                }
            })
            .finally(() => {
                this.props.setSavingTemplate(false)
            })
    }

    changeLevels = (altLevels: string[], levelsMode: LevelsModeType) => {
        const { router } = this.props

        const templateId = router.params.template_id || 'new'
        const alternativeTemplateId = router.params.alt_template_id || 'new'
        const alternativeTemplatesLevels: AlternativeTemplatesLevels[] = this.props.alternativeTemplatesLevels.data ?? []


        const sortedE = sortBy(altLevels)
        const updatedLevels = sortedE.join(',')
        const updatedMode = levelsMode

        this.setState({
            altLevels: sortedE,
            levelsMode: levelsMode
        })

        let foundExisting: boolean = null

        const newLevels: AlternativeTemplatesLevels[] = alternativeTemplatesLevels.map(alternativeTemplateLevels => {
            if (`${alternativeTemplateLevels.template_id}` === `${templateId}` && `${alternativeTemplateLevels.alternative_template_id}` === `${alternativeTemplateId}`) {
                foundExisting = true
                return {
                    ...alternativeTemplateLevels,
                    alternative_template_id: alternativeTemplateLevels?.alternative_template_id || alternativeTemplateId,
                    template_id: alternativeTemplateLevels?.template_id || templateId,
                    levels: updatedLevels,
                    levels_mode: updatedMode,
                    id: alternativeTemplateLevels?.id,
                    project_id: alternativeTemplateLevels?.project_id || projectId,
                    updated_at: alternativeTemplateLevels?.updated_at,
                    created_at: alternativeTemplateLevels?.created_at
                }
            } else {
                return alternativeTemplateLevels
            }
        })

        if (foundExisting) {
            this.props.setAlternativeTemplatesLevelsToStore(newLevels)
        } else {
            const newLevel: AlternativeTemplatesLevels = {
                id: null,
                alternative_template_id: alternativeTemplateId,
                template_id: templateId,
                project_id: projectId,
                levels: updatedLevels,
                levels_mode: updatedMode,
                priority: null,
                updated_at: null,
                created_at: null,
            }
            this.props.setAlternativeTemplatesLevelsToStore([newLevel])
        }

        this.updateEffectsDebounced()
    }

    render() {
        const { templates, checkIsValid, isAlt, router, randomProduct } = this.props
        const { name, altLevels, levelsMode } = this.state

        const c = randomProduct?.alternative_images?.length || 0

        const first = find(randomProduct.alternative_images, (alt) => {
            return `${alt.level}` === '0'
        })

        const last = find(randomProduct.alternative_images, (alt) => {
            return `${alt.level}` === `${c-1}`
        })

        return (
            <StyledGrid cols={isAlt ? '29% auto min-content' : '1fr auto'} gap={isAlt ? 2 : 10}>
                <GridCell className={'above-undo-redo'}>
                    <TextInput
                        id='template-name'
                        value={this.state.name}
                        invalid={checkIsValid && !name || name?.length > MAX_TEMPLATE_NAME_LENGHT-1}
                        error={name?.length > MAX_TEMPLATE_NAME_LENGHT-1 ? trans('template_name_max_100') : ''}
                        onChange={this.handleChangeName}
                        maxLength={MAX_TEMPLATE_NAME_LENGHT}
                        placeholder={trans("template_name")}
                    />
                </GridCell>

                {isAlt &&
                    <GridCell className={'above-undo-redo'}>
                        <Grid cols={'35% 65%'}>
                            <GridCell col={levelsMode !== LEVELS_MODE_SELECTED ? '1/-1' : undefined}>
                                <StyledSelect
                                    key={`c_${c}`}
                                    title={trans('mode')}
                                    placeholder={trans('mode')}
                                    options={levelsModeOptions(first, last)}
                                    value={levelsMode ? levelsMode : LEVELS_MODE_ALL}
                                    className={'left'}
                                    onChange={(e) => this.changeLevels(altLevels, e)}
                                    onClear={() => this.changeLevels(altLevels, null)}
                                    clearable={false}
                                />
                            </GridCell>

                            {levelsMode === LEVELS_MODE_SELECTED &&
                                <GridCell>
                                    <StyledSelect
                                        key={`select_alt_${c}_${levelsMode}`}
                                        title={trans('levels')}
                                        placeholder={trans('levels')}
                                        multiple={true}
                                        /* isMulti
                                        keepOpen={true}
                                        isClearable={false} */
                                        options={availableLevels(randomProduct.alternative_images)}
                                        value={altLevels || []}
                                        className={'left'}
                                        style={{ textAlign: 'center' }}
                                        onChange={(e) => this.changeLevels(e, levelsMode)}
                                        onClear={() => this.changeLevels([], levelsMode)}
                                        clearable={false}
                                    />
                                </GridCell>
                            }
                        </Grid>
                    </GridCell>
                }
                <GridCell className={'above-undo-redo'}>
                    <div>
                        <Button
                            size={"big"}
                            icon={templates.isSaving ? <Icon type={'spinner'} size={iconSize} text={trans('saving')} /> : undefined}
                            onClick={() => this.saveTemplate(false, false)}
                            color={Theme.green}
                            disabled={templates.isSaving}
                            actions={[
                                { label: trans('save_and_exit'), onClick: () => this.saveTemplate(true, false) },
                                { label: trans('save_as_new_template'), onClick: () => this.saveTemplate(false, true) },

                            ]}
                        >{trans('save')}</Button>
                    </div>
                </GridCell>
            </StyledGrid>
        )
    }
}

const StyledGrid = css(Grid)({
    '.muk-textinput input': {
        height: "50px",
        lineHeight: "50px",
    },
    ' .muk-button': {
        whiteSpace: "nowrap",
    },
    ' .muk-gridcell': {
        alignSelf: 'center',
    },
    " .actions-wrapper": {
        "button": {
            paddingTop: "12px",
            paddingBottom: "13px",
            borderRadius: 0,
        },
        "ul": {
            zIndex: 1000
        }
    },
    marginBottom: '10px',
})

const StyledSelect = css(Select)({
    'input': {
        padding: '10px',
        background: 'white',
    },
    ' button:has([class*="muk-icon--close-light"])': {
        display: 'none',
    },
    /* ':has(+ [class*="-indicatorSeparator"])': {
        display: 'none',
    }, */
    /* '[class*="-indicatorContainer"]': {
        display: 'none',
    }, */
    /* '[class*=control]': {
        overflow: 'hidden',
        ' > div:nth-of-type(2)': {
            display: 'none',
        }
    }, */
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        collageLayoutsForm: selectFormValues(state, 'collageLayoutsForm'),
        templates: state.templates,
        sizes: state.sizes,
        randomProduct: state.randomProduct,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
    }
}

export default connect(mapStateToProps, {
    change,
    setSavingTemplate,
    setTemplatesToStore,
    setSizesToStore,
    setAlternativeTemplatesToStore,
    setAlternativeTemplatesLevelsToStore,
    setActiveView,
    setBlockNavigation,
    createToast,
    clearHistory,
    initForm,
})(withRouter(SaveTemplateForm))

